export default (...props) => props
  .reduce((a, x) => [...a, ...multiply(x)], []);

const multiply = x => Array.isArray(x)
  ? Array.from({ length: x[1] }, () => x[0])
  : [x];
